module.exports = "images/slash.513ce292.png";